import React, { useState } from 'react';
import { useCart } from '../contexts/CartContext';
import { useNavigate } from 'react-router-dom';

export default function Checkout() {
  const { cart, updateShipping, updatePayment, getSubtotal } = useCart();
  const navigate = useNavigate();
  const [shipping, setShipping] = useState(cart?.shipping || { name: '', phone: '', address: '', country: '', city: '', zip: '', method: 'standard' });
  const [payment, setPayment] = useState(cart?.payment || { method: 'cod' });

  const onSubmit = async (e) => {
    e.preventDefault();
    await updateShipping(shipping);
    await updatePayment(payment);
    navigate('/order-summary');
  };

  return (
    <div className="page-container">
      <header className="page-header">
        <h1>Checkout</h1>
      </header>
      <form className="add-product-container" onSubmit={onSubmit}>
        <h2>Shipping Information</h2>
        <div className="form-row">
          <div className="form-group">
            <label>Name</label>
            <input value={shipping.name} onChange={(e)=>setShipping({...shipping, name:e.target.value})} required />
          </div>
          <div className="form-group">
            <label>Phone</label>
            <input value={shipping.phone} onChange={(e)=>setShipping({...shipping, phone:e.target.value})} required />
          </div>
        </div>
        <div className="form-group">
          <label>Address</label>
          <input value={shipping.address} onChange={(e)=>setShipping({...shipping, address:e.target.value})} required />
        </div>
        <div className="form-row">
          <div className="form-group">
            <label>Country</label>
            <input value={shipping.country} onChange={(e)=>setShipping({...shipping, country:e.target.value})} required />
          </div>
          <div className="form-group">
            <label>City</label>
            <input value={shipping.city} onChange={(e)=>setShipping({...shipping, city:e.target.value})} required />
          </div>
        </div>
        <div className="form-group">
          <label>ZIP Code</label>
          <input value={shipping.zip} onChange={(e)=>setShipping({...shipping, zip:e.target.value})} required />
        </div>

        <h2>Shipping Method</h2>
        <div className="form-group">
          <label>Choose</label>
          <select value={shipping.method} onChange={(e)=>setShipping({ ...shipping, method: e.target.value })}>
            <option value="standard">Standard Shipping (9-14 business days)</option>
            <option value="express">Express Shipping (5-8 business days)</option>
          </select>
        </div>

        <h2>Payment</h2>
        <div className="form-group">
          <label>Method</label>
          <select value={payment.method} onChange={(e)=>setPayment({ method: e.target.value })}>
            <option value="cod">Cash on Delivery (COD)</option>
            <option value="card">Card (via Stripe - later)</option>
          </select>
        </div>

        <p><strong>Order total:</strong> ${getSubtotal().toFixed(2)}</p>

        <div className="form-actions">
          <button type="submit" className="submit-button">Save Order</button>
        </div>
      </form>
    </div>
  );
}


